export const colors = {
  text: "#FFFFFF",
  backgroundField: "rgba(255, 255, 255, 0.16);",
  highLight: "rgba(80, 129, 251, 0.08);",
  background: "#051D3B",
  buttonSave: "#5081FB",
  blue1: "#7BA4FC",
  blue2: "#96B9FD",
  shadowBorder: "rgba(0, 0, 0, 0.24)",
  border: "#C4C4C4",
  backgroundEditor: "#141414",
  containerBlue: "#6BD1FF",
  choiceBorder: "rgba(196, 196, 196, 0.01)",
  textSave: "#051D3B",
  containerGreen: "#9AFF6B",
  containerOrange: "#FFC46B",
  containerPurple: "#6B83FF",
  containerPink: "#FF6BCD",
};
